module.exports = __webpack_public_path__ + "media/svg/events-selected-3e634051.svg";